import styled from 'styled-components';
import tw, { classnames, margin, padding, fontSize, textColor, fontWeight, position, display, gridTemplateColumns, space, flexDirection, textAlign, borderColor } from 'tailwindcss-classnames';

export const Container = styled.div.attrs({
    className: classnames(margin('mb-8'), padding('py-1'))
})``;

export const Title = styled.h2.attrs({
    className: classnames(textColor('text-gpas-700' as any, 'dark:text-gray-300' as any), fontSize('text-3xl'), padding('pb-1'), fontWeight('font-bold'))
})``;

export const Subtitle = styled.h4.attrs({
    className: classnames(textColor('text-gray-600'))
})``

export const NavContainer = styled.div.attrs({
    className: classnames(position('relative'), padding('pt-6'), display('flex', 'grid'), gridTemplateColumns('grid-cols-1', 'md:grid-cols-3'), space('md:space-x-4'))
})``;

export const NavCardContainer = styled.div.attrs({
    className: classnames(position('relative'), padding('pb-2', 'md:pb-0'))
})`
`;

export const NavItem = styled.div.attrs({
    className: classnames(flexDirection('flex-col'), textAlign('text-center'), padding('py-8'), margin('mx-8'))
})`
    min-height: 140px;
`;

export const ItemTitle = styled.h3.attrs({
    className: classnames(textColor('dark:text-gray-400' as any), borderColor('border-purple-800'), padding('py-4'))
})`
    font-weight: 600;
    font-size: 1.4rem;
`;

export const ItemSubtitle = styled.p.attrs({
    className: classnames(textColor('dark:text-gray-400' as any), borderColor('border-gray-300'))
})``;
